import { connect } from 'react-redux';
import EventsListModal from '../components/events_list_modal';
import { selectIsManagerSite, selectEnabledSummaryKeys, selectOpenSummaryKey } from '../selectors';
import { isSummariesOnlyRound } from '../utils/events_utils';

const mapStateToProps = (state, ownProps) => {
  // Highlight the open event or summary only in the committed round's list: a
  // multi-round event must not light up while previewing its other rounds. No
  // selectedRoundId ownProp means the list is the current round's.
  const isCurrentRound = ownProps.selectedRoundId == null ||
    String(ownProps.selectedRoundId) === String(state.leaderboardV2.roundId);

  const eventsList = ownProps.previewEvents || state.leaderboardV2.eventsList;
  const listedRoundId = ownProps.selectedRoundId ?? state.leaderboardV2.roundId;

  return {
    eventsList,
    showEmptyState:
      Object.keys(eventsList).length === 0 &&
      !isSummariesOnlyRound(state.leaderboardV2.roundList, listedRoundId),
    favoritesByEvent: state.leaderboardV2.favoritesByEvent,
    selectedEventId: isCurrentRound ? (Object.keys(state.event)[0] || null) : null,
    selectedSummaryKey: isCurrentRound ? selectOpenSummaryKey(state) : null,
    enabledSummaryKeys: selectEnabledSummaryKeys(state),
    isManagerSite: selectIsManagerSite(state),
  };
};

export default connect(mapStateToProps)(EventsListModal);
